import axios from "@/util/axios";

export default {
    queryByTree: ()=> axios.get({url: "/basedata/base/common/mini/home/route/queryByTree"})
}